import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

interface RequireAuthProps {
  children: React.ReactNode;
}

export const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthed, setIsAuthed] = useState<boolean | null>(null);
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    const checkAuth = async () => {
      try {
        await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:3002'}/api/v1/auth/me`, {
          withCredentials: true,
        });
        if (isMounted) {
          setIsAuthed(true);
        }
      } catch {
        if (isMounted) {
          setIsAuthed(false);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };
    checkAuth();
    return () => {
      isMounted = false;
    };
  }, []);

  if (isLoading) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" minHeight="100vh" gap={2}>
        <CircularProgress size={24} />
        <Typography>Checking your session…</Typography>
      </Box>
    );
  }

  if (!isAuthed) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};
